import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const StepperContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin: 0 -2px;
`

export const Step = styled.div`
    height: 2px;
    border-radius: 10px;
    background-color: #595959;
    flex: 1 0 auto;
    margin: 0 2px;

    &.active {
        background-color: ${theme.colors.primary};
    }
`
